import {Mapper} from '@s-ui/domain'

export class SeoMetaInformationMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {SeoAdsListMetaInformationMapper} deps.seoAdsListMetaInformationMapper
   * @param {SeoAdsListSubscriptionMetaInformationMapper} deps.seoAdsListSubscriptionMetaInformationMapper
   * @param {SeoAdsDetailMetaInformationMapper} deps.seoAdsDetailMetaInformationMapper
   * @param {SeoDealersListMetaInformationMapper} deps.seoDealersListMetaInformationMapper
   * @param {SeoProfessionalStockMetaInformationMapper} deps.seoProfessionalStockMetaInformationMapper
   * @param {SeoTechnicalDetailsMetaInformationMapper} deps.seoTechnicalDetailsMetaInformationMapper
   * @param {SeoTechnicalDetailsSearchMetaInformationMapper} deps.seoTechnicalDetailsSearchMetaInformationMapper
   * @param {SeoLandingFinancingMetaInformationMapper} deps.seoLandingFinancingMetaInformationMapper
   * @param {SeoLandingFormalitiesMetaInformationMapper} deps.seoLandingFormalitiesMetaInformationMapper
   * @param {SeoPublishYourAdMetaInformationMapper} deps.seoPublishYourAdMetaInformationMapper
   * @param {SeoInsuranceMetaInformationMapper} deps.seoInsuranceMetaInformationMapper
   * @param {SeoNewsListMetaInformationMapper} deps.seoNewsListMetaInformationMapper
   * @param {FromNewsDetailPageMetaInformationToSeoDataVOMapper} deps.fromNewsDetailPageMetaInformationToSeoDataVOMapper
   * @param {SeoMakesDistributorMetaInformationMapper} deps.seoMakesDistributorMetaInformationMapper
   * @param {SeoModelDetailMetaInformationMapper} deps.seoModelDetailMetaInformationMapper
   * @param {SeoVehicleAppraiserMetaInformationMapper} deps.seoVehicleAppraiserMetaInformationMapper
   * @param {SeoLandingFormalitiesSecurityGuidelinesMetaInformationMapper} deps.SeoLandingFormalitiesSecurityGuidelinesMetaInformationMapper
   * @param {seoHomeMetaInformationMapper} deps.seoHomeMetaInformationMapper
   * @param {seoStaticMetaInformationMapper} deps.seoStaticMetaInformationMapper
   * @param {Object} deps.config
   * */
  constructor({
    seoAdsListMetaInformationMapper,
    seoAdsListSubscriptionMetaInformationMapper,
    seoAdsDetailMetaInformationMapper,
    seoDealersListMetaInformationMapper,
    seoInstantOfferStandaloneMetaInformationMapper,
    seoInsuranceMetaInformationMapper,
    seoNewsListMetaInformationMapper,
    fromNewsDetailPageMetaInformationToSeoDataVOMapper,
    seoMakeMetaInformationMapper,
    seoMakesDistributorMetaInformationMapper,
    seoModelDetailMetaInformationMapper,
    seoModelSizesMetaInformationMapper,
    seoProfessionalStockMetaInformationMapper,
    seoTechnicalDetailsMetaInformationMapper,
    seoTechnicalDetailsSearchMetaInformationMapper,
    seoLandingFinancingMetaInformationMapper,
    seoLandingFormalitiesMetaInformationMapper,
    seoLandingFormalitiesSecurityGuidelinesMetaInformationMapper,
    seoLandingInstantOfferMetaInformationMapper,
    // web_seller_instant_offer_landing_test
    seoLandingInstantOfferTestMetaInformationMapper,
    seoEditMyAdMetaInformationMapper,
    seoPublishMyAdMetaInformationMapper,
    seoPublishMyAdCategoryMetaInformationMapper,
    seoPublishYourAdMetaInformationMapper,
    seoPublishYourAdWithPlateMetaInformationMapper,
    seoVehicleAppraiserMetaInformationMapper,
    seoHomeMetaInformationMapper,
    seoDataRequestErrorFactory,
    seoStaticMetaInformationMapper,
    config
  }) {
    super()

    this._seoAdsListMetaInformationMapper = seoAdsListMetaInformationMapper
    this._seoAdsListSubscriptionMetaInformationMapper = seoAdsListSubscriptionMetaInformationMapper
    this._seoAdsDetailMetaInformationMapper = seoAdsDetailMetaInformationMapper
    this._seoDealersListMetaInformationMapper = seoDealersListMetaInformationMapper
    this._seoInstantOfferStandaloneMetaInformationMapper = seoInstantOfferStandaloneMetaInformationMapper
    this._seoInsuranceMetaInformationMapper = seoInsuranceMetaInformationMapper
    this._seoMakeMetaInformationMapper = seoMakeMetaInformationMapper
    this._seoMakesDistributorMetaInformationMapper = seoMakesDistributorMetaInformationMapper
    this._seoModelDetailMetaInformationMapper = seoModelDetailMetaInformationMapper
    this._seoModelSizesMetaInformationMapper = seoModelSizesMetaInformationMapper
    this._seoNewsListMetaInformationMapper = seoNewsListMetaInformationMapper
    this._fromNewsDetailPageMetaInformationToSeoDataVOMapper = fromNewsDetailPageMetaInformationToSeoDataVOMapper
    this._seoProfessionalStockMetaInformationMapper = seoProfessionalStockMetaInformationMapper
    this._seoTechnicalDetailsMetaInformationMapper = seoTechnicalDetailsMetaInformationMapper
    this._seoTechnicalDetailsSearchMetaInformationMapper = seoTechnicalDetailsSearchMetaInformationMapper
    this._seoLandingFinancingMetaInformationMapper = seoLandingFinancingMetaInformationMapper
    this._seoLandingFormalitiesMetaInformationMapper = seoLandingFormalitiesMetaInformationMapper
    this._seoLandingFormalitiesSecurityGuidelinesMetaInformationMapper =
      seoLandingFormalitiesSecurityGuidelinesMetaInformationMapper
    this._seoLandingInstantOfferMetaInformationMapper = seoLandingInstantOfferMetaInformationMapper
    // web_seller_instant_offer_landing_test
    this._seoLandingInstantOfferTestMetaInformationMapper = seoLandingInstantOfferTestMetaInformationMapper
    this._seoEditMyAdMetaInformationMapper = seoEditMyAdMetaInformationMapper
    this._seoPublishMyAdMetaInformationMapper = seoPublishMyAdMetaInformationMapper
    this._seoPublishMyAdCategoryMetaInformationMapper = seoPublishMyAdCategoryMetaInformationMapper
    this._seoPublishYourAdMetaInformationMapper = seoPublishYourAdMetaInformationMapper
    this._seoPublishYourAdWithPlateMetaInformationMapper = seoPublishYourAdWithPlateMetaInformationMapper
    this._seoVehicleAppraiserMetaInformationMapper = seoVehicleAppraiserMetaInformationMapper
    this._seoHomeMetaInformationMapper = seoHomeMetaInformationMapper
    this._seoDataRequestErrorFactory = seoDataRequestErrorFactory
    this._seoStaticMetaInformationMapper = seoStaticMetaInformationMapper
    this._config = config
  }

  createFor = ({pageName = ''}) => {
    const {
      ADS_DETAIL_PAGE_NAME,
      ADS_DETAIL_PREVIEW_PAGE_NAME,
      ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME,
      ADS_LIST_BUGGIES_NEW_PAGE_NAME,
      ADS_LIST_BUGGIES_PAGE_NAME,
      ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME,
      ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME,
      ADS_LIST_MINIMOTOS_NEW_PAGE_NAME,
      ADS_LIST_MINIMOTOS_PAGE_NAME,
      ADS_LIST_NEW_PAGE_NAME,
      ADS_LIST_PAGE_NAME,
      ADS_LIST_QUADS_NEW_PAGE_NAME,
      ADS_LIST_QUADS_PAGE_NAME,
      ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME,
      ADS_LIST_SUBSCRIPTION_PAGE_NAME,
      ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME,
      CHECKOUT_ACTIVATION_ERROR_PAGE_NAME,
      CHECKOUT_ERROR_PAGE_NAME,
      CHECKOUT_PAGE_NAME,
      CHECKOUT_PENDING_PAGE_NAME,
      CHECKOUT_REFUND_ERROR_PAGE_NAME,
      CHECKOUT_REQUEST_ERROR_PAGE_NAME,
      CHECKOUT_SUCCESS_PAGE_NAME,
      CHECKOUT_UNKNOWN_ERROR_PAGE_NAME,
      DEALERS_LIST_PAGE_NAME,
      HOME_PAGE_NAME,
      INSTANT_OFFER_SELL_TO_DEALER_PAGE_NAME,
      INSTANT_OFFER_STANDALONE_PAGE_NAME,
      INSURANCE_PAGE_NAME,
      LANDING_FINANCING_PAGE_NAME,
      LANDING_FORMALITIES_PAGE_NAME,
      LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME,
      LANDING_INSTANT_OFFER_PAGE_NAME,
      // web_seller_instant_offer_landing_test
      LANDING_INSTANT_OFFER_TEST_PAGE_NAME,
      LOGIN_PAGE_NAME,
      MAKE_PAGE_NAME,
      MAKES_DISTRIBUTOR_PAGE_NAME,
      MAKES_SIZES_DISTRIBUTOR_PAGE_NAME,
      MODEL_DETAIL_PAGE_NAME,
      MODEL_DETAIL_INTERIOR_PAGE_NAME,
      MODEL_DETAIL_TRUNK_PAGE_NAME,
      MODEL_SIZES_PAGE_NAME,
      NEWS_CATEGORY_PAGE_NAME,
      NEWS_DETAIL_PAGE_NAME,
      NEWS_COMMENTS_PAGE_NAME,
      NEWS_SEARCH_PAGE_NAME,
      NEWS_SECTION_TIPS_PAGE_NAME,
      NEWS_SECTION_TRENDS_PAGE_NAME,
      NEWS_TAG_PAGE_NAME,
      OTHER_PARTNERS_PAGE_NAME,
      PAYMENT_AD_REQUEST_PAGE_NAME,
      PRODUCTS_PAGE_NAME,
      PROFESSIONAL_STOCK_PAGE_NAME,
      PROFESSIONAL_STOCK_RENTING_PAGE_NAME,
      PROFESSIONALS_PAGE_NAME,
      PUBLISH_MY_AD_PAGE_NAME,
      PUBLISH_MY_AD_CATEGORY_PAGE_NAME,
      EDIT_MY_AD_PAGE_NAME,
      PUBLISH_YOUR_VEHICLE_PAGE_NAME,
      PUBLISH_YOUR_VEHICLE_PATH_WITH_PLATE_PAGE_NAME,
      TECHNICAL_DETAILS_BODY_TYPE_PAGE_NAME,
      TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME,
      TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME,
      TECHNICAL_DETAILS_HOME_PAGE_NAME,
      TECHNICAL_DETAILS_MAKE_PAGE_NAME,
      TECHNICAL_DETAILS_MODEL_PAGE_NAME,
      TECHNICAL_DETAILS_SEARCH_PAGE_NAME,
      TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME,
      TECHNICAL_DETAILS_VEHICLE_PAGE_NAME,
      TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME,
      TECHNICAL_DETAILS_VERSION_PAGE_NAME,
      TERMS_OF_SERVICE_PAGE_NAME,
      TRANSPARENCY_PAGE_NAME,
      TERMS_OF_SERVICE_RESERVATION_PAGE_NAME,
      USER_DISCOUNTS_PAGE_NAME,
      USER_ALERTS_MATCHES_PAGE_NAME,
      USER_FAVORITE_ADS_PAGE_NAME,
      USER_PROFILE_PAGE_NAME,
      USER_PROFILE_EDIT_PAGE_NAME,
      USER_SAVED_SEARCHES_PAGE_NAME,
      VEHICLE_APPRAISER_PAGE_NAME,
      COMPARADOR_PAGE_NAME,
      NET_PAGE_NAME,
      MY_ADS_PAGE_NAME
    } = this._config.get('page')

    switch (pageName) {
      case ADS_DETAIL_PAGE_NAME:
      case ADS_DETAIL_PREVIEW_PAGE_NAME:
        return this._seoAdsDetailMetaInformationMapper
      case ADS_LIST_PAGE_NAME:
      case ADS_LIST_BUGGIES_PAGE_NAME:
      case ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME:
      case ADS_LIST_MINIMOTOS_PAGE_NAME:
      case ADS_LIST_QUADS_PAGE_NAME:
      case ADS_LIST_NEW_PAGE_NAME:
      case ADS_LIST_BUGGIES_NEW_PAGE_NAME:
      case ADS_LIST_MINIMOTOS_NEW_PAGE_NAME:
      case ADS_LIST_QUADS_NEW_PAGE_NAME:
      case ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME:
      case ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME:
      case ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME:
        return this._seoAdsListMetaInformationMapper
      case ADS_LIST_SUBSCRIPTION_PAGE_NAME:
      case ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME:
        return this._seoAdsListSubscriptionMetaInformationMapper
      case DEALERS_LIST_PAGE_NAME:
        return this._seoDealersListMetaInformationMapper
      case EDIT_MY_AD_PAGE_NAME:
        return this._seoEditMyAdMetaInformationMapper
      case HOME_PAGE_NAME:
        return this._seoHomeMetaInformationMapper
      case INSTANT_OFFER_SELL_TO_DEALER_PAGE_NAME:
      case INSTANT_OFFER_STANDALONE_PAGE_NAME:
        return this._seoInstantOfferStandaloneMetaInformationMapper
      case INSURANCE_PAGE_NAME:
        return this._seoInsuranceMetaInformationMapper
      case MAKE_PAGE_NAME:
        return this._seoMakeMetaInformationMapper
      case MAKES_DISTRIBUTOR_PAGE_NAME:
        return this._seoMakesDistributorMetaInformationMapper
      case MAKES_SIZES_DISTRIBUTOR_PAGE_NAME:
        return this._seoMakesDistributorMetaInformationMapper
      case MODEL_DETAIL_INTERIOR_PAGE_NAME:
      case MODEL_DETAIL_PAGE_NAME:
      case MODEL_DETAIL_TRUNK_PAGE_NAME:
      case MODEL_SIZES_PAGE_NAME:
        return this._seoModelDetailMetaInformationMapper
      case NEWS_CATEGORY_PAGE_NAME:
      case NEWS_TAG_PAGE_NAME:
      case NEWS_SEARCH_PAGE_NAME:
      case NEWS_SECTION_TIPS_PAGE_NAME:
      case NEWS_SECTION_TRENDS_PAGE_NAME:
        return this._seoNewsListMetaInformationMapper
      case NEWS_COMMENTS_PAGE_NAME:
      case NEWS_DETAIL_PAGE_NAME:
        return this._fromNewsDetailPageMetaInformationToSeoDataVOMapper
      case PROFESSIONAL_STOCK_PAGE_NAME:
      case PROFESSIONAL_STOCK_RENTING_PAGE_NAME:
        return this._seoProfessionalStockMetaInformationMapper
      case TECHNICAL_DETAILS_HOME_PAGE_NAME:
      case TECHNICAL_DETAILS_MAKE_PAGE_NAME:
      case TECHNICAL_DETAILS_MODEL_PAGE_NAME:
      case TECHNICAL_DETAILS_BODY_TYPE_PAGE_NAME:
      case TECHNICAL_DETAILS_VERSION_PAGE_NAME:
      case TECHNICAL_DETAILS_VEHICLE_PAGE_NAME:
      case TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME:
      case TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME:
      case TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME:
        return this._seoTechnicalDetailsMetaInformationMapper
      case TECHNICAL_DETAILS_SEARCH_PAGE_NAME:
      case TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME:
        return this._seoTechnicalDetailsSearchMetaInformationMapper
      case LANDING_FINANCING_PAGE_NAME:
        return this._seoLandingFinancingMetaInformationMapper
      case LANDING_FORMALITIES_PAGE_NAME:
        return this._seoLandingFormalitiesMetaInformationMapper
      case LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME:
        return this._seoLandingFormalitiesSecurityGuidelinesMetaInformationMapper
      case LANDING_INSTANT_OFFER_PAGE_NAME:
        return this._seoLandingInstantOfferMetaInformationMapper
      // web_seller_instant_offer_landing_test
      case LANDING_INSTANT_OFFER_TEST_PAGE_NAME:
        return this._seoLandingInstantOfferTestMetaInformationMapper
      case PUBLISH_MY_AD_PAGE_NAME:
        return this._seoPublishMyAdMetaInformationMapper
      case PUBLISH_MY_AD_CATEGORY_PAGE_NAME:
        return this._seoPublishMyAdCategoryMetaInformationMapper
      case PUBLISH_YOUR_VEHICLE_PAGE_NAME:
        return this._seoPublishYourAdMetaInformationMapper
      case PUBLISH_YOUR_VEHICLE_PATH_WITH_PLATE_PAGE_NAME:
        return this._seoPublishYourAdWithPlateMetaInformationMapper
      case VEHICLE_APPRAISER_PAGE_NAME:
        return this._seoVehicleAppraiserMetaInformationMapper
      case CHECKOUT_PAGE_NAME:
      case CHECKOUT_SUCCESS_PAGE_NAME:
      case CHECKOUT_ERROR_PAGE_NAME:
      case CHECKOUT_PENDING_PAGE_NAME:
      case CHECKOUT_ACTIVATION_ERROR_PAGE_NAME:
      case CHECKOUT_REQUEST_ERROR_PAGE_NAME:
      case CHECKOUT_REFUND_ERROR_PAGE_NAME:
      case CHECKOUT_UNKNOWN_ERROR_PAGE_NAME:
      case PRODUCTS_PAGE_NAME:
      case LOGIN_PAGE_NAME:
      case TERMS_OF_SERVICE_PAGE_NAME:
      case TRANSPARENCY_PAGE_NAME:
      case TERMS_OF_SERVICE_RESERVATION_PAGE_NAME:
      case OTHER_PARTNERS_PAGE_NAME:
      case PAYMENT_AD_REQUEST_PAGE_NAME:
      case USER_DISCOUNTS_PAGE_NAME:
      case USER_ALERTS_MATCHES_PAGE_NAME:
      case USER_PROFILE_PAGE_NAME:
      case USER_PROFILE_EDIT_PAGE_NAME:
      case USER_FAVORITE_ADS_PAGE_NAME:
      case USER_SAVED_SEARCHES_PAGE_NAME:
      case PROFESSIONALS_PAGE_NAME:
      case COMPARADOR_PAGE_NAME:
      case NET_PAGE_NAME:
      case MY_ADS_PAGE_NAME:
        return this._seoStaticMetaInformationMapper
    }
  }

  /**
   * @method
   */
  async map({culture, pageName, params = {}, preloadImages}) {
    const pageMapper = this.createFor({pageName})

    if (!pageMapper) throw this._seoDataRequestErrorFactory('Invalid pageName')

    return pageMapper.map({culture, pageName, params, preloadImages})
  }
}
